import React from 'react';

import { Input } from '../../../../components/Input/index';
import { Select } from '../../../../components/Select/index';
import { Trans, i18nMark } from 'lingui-react';

import './companyInfo.css';

export const CompanyInfo = (props) => {
  return (
    <div className="company-info">
      <div className="title-card">
        <span className="title-number">1</span><Trans id="Company Details" />
      </div>
      <div className="row">
        <div className="col-12 content-input">
          <Input
            labelName={<Trans id="* Company Name" />}
            inputStyle="input-company"
            labelStyle="label-input-company"
            placeHolder={props.i18n._(i18nMark('Your company name'))}
            validationMessages={props.validationMessages.companyName}
            type="text"
            name="companyName"
            value={props.companyInfo.companyName}
            onChange={props.onInputChange}
            id="txtCompanyName"
          />
          <Select
            labelName={<Trans id="* Industry" />}
            placeHolder={props.i18n._(i18nMark('Choose your industry'))}
            validationMessages={props.validationMessages.industry}
            value={props.companyInfo.industry}
            data={props.industries}
            labelField="name_en"
            valueField="_id"
            onChange={props.onSelectIndustry}
            id="sltIndustry"
          />
          <Select
            labelName={<Trans id="* Legal Form" />}
            placeHolder={props.i18n._(i18nMark('Choose your legal form'))}
            validationMessages={props.validationMessages.legalForm}
            value={props.companyInfo.legalForm}
            data={props.legalForms}
            onChange={props.onSelectLegalForm}
            id="sltLegalForm"
          />
          <Select
            labelName={<Trans id="* Number of Employees" />}
            placeHolder={props.i18n._(i18nMark('Choose your number of employees'))}
            validationMessages={props.validationMessages.numberOfEmployees}
            value={props.companyInfo.numberOfEmployees}
            data={props.numberOfEmployees}
            onChange={props.onSelectNumberOfEmployees}
            id="sltNumberOfEmployees"
          />
          <Input
            labelName={<Trans id="Address" />}
            inputStyle="textarea-company"
            labelStyle="label-input-company"
            placeHolder={props.i18n._(i18nMark('Your company address'))}
            validationMessages={props.validationMessages.address}
            type="textarea"
            rows="3"
            name="address"
            value={props.companyInfo.address}
            onChange={props.onInputChange}
            id="txtAddress"
          />
          <Input
            labelName={<Trans id="Headquarter" />}
            inputStyle="input-company"
            labelStyle="label-input-company"
            placeHolder={props.i18n._(i18nMark('Where is your headquarter located?'))}
            validationMessages={props.validationMessages.headquarter}
            type="text"
            name="headquarter"
            value={props.companyInfo.headquarter}
            onChange={props.onInputChange}
            id="txtHeadquarter"
          />
          <Input
            labelName={<Trans id="Branches" />}
            inputStyle="input-company"
            labelStyle="label-input-company"
            placeHolder={props.i18n._(i18nMark('Where are your other branches located?'))}
            validationMessages={props.validationMessages.branches}
            type="text"
            name="branches"
            value={props.companyInfo.branches}
            onChange={props.onInputChange}
            id="txtBranches"
          />
        </div>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/screens/Company/components/CompanyInfo/CompanyInfo.js